import React from 'react';
import { Segmented } from 'antd';
import { List, Map as MapIcon } from 'lucide-react';

/** Listado / Mapa view switch. */
function StoreTabs({ tab, setTab }) {
    const tabs = [
        { value: 0, label: 'Listado', icon: <List /> },
        { value: 1, label: 'Mapa', icon: <MapIcon /> }
    ];

    return <Segmented value={tab} onChange={(value) => setTab(value)} options={tabs} />;
}

export default StoreTabs;
